export default __webpack_public_path__ + "static/media/715.ca903827.png";